var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjectReportsGraphic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38.07,
    y: 66.69,
    width: 242.02,
    height: 202.67,
    style: {
      fill: "#ebf2f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.25,
    y: 39.57,
    width: 162.47,
    height: 245.02,
    style: {
      fill: "#d2e4ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.74,166.53s13.85,14.3,14.52,19.69S310.67,200,310.67,200Z",
    style: {
      fill: "#e58638"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.82,314.86s-.47,7.6-1.94,7.71h-7.46l-9.27-.05a3,3,0,0,1,2.77-2.71c2.71-.47,7.25-2.38,8.89-6C291.54,310.09,296.82,314.86,296.82,314.86Z",
    style: {
      fill: "#163560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.47,314.86s-.47,7.6-1.94,7.71h-7.46l-9.3,0a3.07,3.07,0,0,1,2.8-2.73c2.71-.47,7.25-2.38,8.89-6C312.19,310.09,317.47,314.86,317.47,314.86Z",
    style: {
      fill: "#163560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.55,233.34s2.43,15.51,11.47,43,10.28,39.46,10.28,39.46a40.49,40.49,0,0,0,5,.35,32.25,32.25,0,0,0,4.67-.62s.08-30.09-4.09-43.94-.9-49.91-.9-49.91Z",
    style: {
      fill: "#163560"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.83,222.57a377.14,377.14,0,0,0,3.7,52.07c4.05,28.69,2.67,40.88,2.67,40.88s3.33.59,4.5.63,5.19-.31,5.19-.31,5.79-28.71,4.13-43.07,7.92-49.29,7.92-49.29Z",
    style: {
      fill: "#1c468a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.58,167.88,296,171.26l-6.6-1.39c.09-.6.53-3.09.92-5.35,0-.14.05-.27.07-.4.34-1.92.64-3.58.64-3.58l6.16-3.07,2.3-1.15c0,.05-.18,2.14-.2,2.44A19.78,19.78,0,0,0,300.58,167.88Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.87,166.17c.15-.06,9-2.67,9.94-2.35s1.53,2.18,1.53,2.18l-14.45,3.26A7.22,7.22,0,0,1,289.87,166.17Z",
    style: {
      fill: "#e58638"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.66,225.46c-1.49,6.83-26.42,7.64-32.84,1.44-.73-.71-.77-4-.49-8.43.53-8.67,2.27-21.7,2.33-28.36a53.32,53.32,0,0,1,1.07-9.49,77.14,77.14,0,0,1,3.16-11.36s12.17-3.93,14.45-3.26C312.32,169.22,315.16,218.62,313.66,225.46Z",
    style: {
      fill: "#ee9849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.33,218.47c.53-8.67,2.27-21.7,2.33-28.36a53.32,53.32,0,0,1,1.07-9.49l7.32-1.29S298.21,208.58,280.33,218.47Z",
    style: {
      fill: "#e58638"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.29,206.39a1.73,1.73,0,0,1-.55,2,3.33,3.33,0,0,0-1.49,3c.24.95,2.54,2.5,3.34,2.25s2.42-1.5,2.25-2,1.09-4.39-.86-5.89S284.29,206.39,284.29,206.39Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.48,167.51s-7.14,1.34-12.83,9.72-9.44,14.62-8.39,17.65,10.6,13.5,12.25,13.5,4.31-1.19,4.46-3.89c0,0-6.73-10.08-5.4-11.59.56-.65,8.73-7.28,9.9-4.29C294.4,193.57,292.48,167.51,292.48,167.51Z",
    style: {
      fill: "#ee9849"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.84,158.86c-1.36,2.59-6.4,4.83-8.51,5.66,0-.14.05-.27.07-.4.34-1.92.64-3.58.64-3.58l6.16-3.07C298.57,157.45,299.4,157.79,298.84,158.86Z",
    style: {
      fill: "#fca56b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.05,160.68s9.13,2.85,10.81-2.86,4-9.19-1.75-11.25-7.54-.22-8.57,1.55S286.72,159.8,289.05,160.68Z",
    style: {
      fill: "#ffb27d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.9,147.57s.58,6.65,2,6.36,2.62-.5,2.42,1.5-2.11,4.32,2.13,4.67,10.32-10.57,9.16-12.63C302.21,141.5,285.05,140.29,289.9,147.57Z",
    style: {
      fill: "#163560"
    }
  }), /*#__PURE__*/React.createElement("image", {
    width: 161,
    height: 227,
    transform: "translate(72.47 40.62)",
    xlinkHref: "data:image/png;base64,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",
    style: {
      mixBlendMode: "multiply",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.32,
    y: 50.62,
    width: 139.36,
    height: 206.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.61,
    y: 77.07,
    width: 126.99,
    height: 4.82,
    rx: 0.33,
    style: {
      fill: "#1c468a",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.61,
    y: 115.37,
    width: 126.99,
    height: 4.82,
    rx: 0.33,
    style: {
      fill: "#1c468a",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.600000023841858
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.92,97.66a.56.56,0,0,1-.2-.28,4,4,0,0,0-4.83-2.78.54.54,0,0,1-.57-.22,4.45,4.45,0,0,0-6.66-.77,4.5,4.5,0,0,0-1.43,2.86.52.52,0,0,1-.3.43l-.16.08a.47.47,0,0,1-.15.06,3.42,3.42,0,0,0-1.91,1.19,3.35,3.35,0,0,0-.77,2.15,3.43,3.43,0,0,0,3.44,3.41h11.45a3.41,3.41,0,0,0,2.09-6.13Z",
    style: {
      fill: "#a6c7f9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.37,97.42a4.78,4.78,0,0,1,2.31-1.54,5.71,5.71,0,0,1,5.49-4.7,6.19,6.19,0,1,0-8.79,8.47A4.51,4.51,0,0,1,101.37,97.42Z",
    style: {
      fill: "#ffdd7d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.600000023841858
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.3,97.55a.54.54,0,0,1-.19-.28,4.1,4.1,0,0,0-4.92-2.83.55.55,0,0,1-.58-.22,4.52,4.52,0,0,0-6.77-.78,4.48,4.48,0,0,0-1.45,2.9.55.55,0,0,1-.31.44l-.17.09-.14,0a3.46,3.46,0,0,0-2,1.21,3.41,3.41,0,0,0-.78,2.19,3.49,3.49,0,0,0,3.5,3.47h11.64a3.47,3.47,0,0,0,2.12-6.24Z",
    style: {
      fill: "#a6c7f9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M185.81,97.31a4.77,4.77,0,0,1,2.35-1.57A5.79,5.79,0,0,1,193.74,91a6.3,6.3,0,1,0-8.94,8.61A4.76,4.76,0,0,1,185.81,97.31Z",
    style: {
      fill: "#ffdd7d"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.61,
    y: 171.26,
    width: 126.99,
    height: 4.82,
    rx: 0.33,
    style: {
      fill: "#1c468a",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.61,
    y: 222.57,
    width: 126.99,
    height: 4.82,
    rx: 0.33,
    style: {
      fill: "#1c468a",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.78,
    y: 124.43,
    width: 126.34,
    height: 18.54,
    style: {
      fill: "#a6c7f9",
      opacity: 0.200000002980232
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.78,
    y: 124.24,
    width: 126.4,
    height: 0.48,
    style: {
      fill: "#1c468a",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.78,
    y: 232.56,
    width: 126.34,
    height: 18.54,
    style: {
      fill: "#a6c7f9",
      opacity: 0.200000002980232
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "89.78 232.85 89.78 232.37 216.18 232.37 216.18 232.85",
    style: {
      fill: "#1c468a",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.61,
    y: 63.48,
    width: 15.59,
    height: 2.39,
    rx: 1.2,
    style: {
      fill: "#a6c7f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.61,
    y: 58.41,
    width: 27.75,
    height: 2.39,
    rx: 1.2,
    style: {
      fill: "#a6c7f9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.57,
    cy: 95.79,
    r: 5.51,
    style: {
      fill: "#ffdd7d"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.57,
    y1: 88.6,
    x2: 153.57,
    y2: 86.96,
    style: {
      fill: "none",
      stroke: "#ffdd7d",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.563455104827881px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.65,
    y1: 90.7,
    x2: 159.81,
    y2: 89.54,
    style: {
      fill: "none",
      stroke: "#ffdd7d",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.563455104827881px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.75,
    y1: 95.79,
    x2: 162.4,
    y2: 95.79,
    style: {
      fill: "none",
      stroke: "#ffdd7d",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.563455104827881px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.65,
    y1: 100.87,
    x2: 159.81,
    y2: 102.03,
    style: {
      fill: "none",
      stroke: "#ffdd7d",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.563455104827881px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.57,
    y1: 102.97,
    x2: 153.57,
    y2: 104.62,
    style: {
      fill: "none",
      stroke: "#ffdd7d",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.563455104827881px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.49,
    y1: 100.87,
    x2: 147.32,
    y2: 102.03,
    style: {
      fill: "none",
      stroke: "#ffdd7d",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.563455104827881px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.38,
    y1: 95.79,
    x2: 144.74,
    y2: 95.79,
    style: {
      fill: "none",
      stroke: "#ffdd7d",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.563455104827881px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.49,
    y1: 90.7,
    x2: 147.32,
    y2: 89.54,
    style: {
      fill: "none",
      stroke: "#ffdd7d",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "2.563455104827881px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.05,
    y: 148.94,
    width: 55.26,
    height: 2.39,
    rx: 1.2,
    style: {
      fill: "#a6c7f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.42,
    y: 148.94,
    width: 20.7,
    height: 2.39,
    rx: 1.2,
    style: {
      fill: "#a6c7f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.45,
    y: 148.94,
    width: 20.7,
    height: 2.39,
    rx: 1.2,
    style: {
      fill: "#a6c7f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.48,
    y: 148.94,
    width: 20.7,
    height: 2.39,
    rx: 1.2,
    style: {
      fill: "#a6c7f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.05,
    y: 155.13,
    width: 55.26,
    height: 2.39,
    rx: 1.2,
    style: {
      fill: "#a6c7f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.42,
    y: 155.13,
    width: 20.7,
    height: 2.39,
    rx: 1.2,
    style: {
      fill: "#a6c7f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.45,
    y: 155.13,
    width: 20.7,
    height: 2.39,
    rx: 1.2,
    style: {
      fill: "#a6c7f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.48,
    y: 155.13,
    width: 20.7,
    height: 2.39,
    rx: 1.2,
    style: {
      fill: "#a6c7f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.05,
    y: 161.32,
    width: 55.26,
    height: 2.39,
    rx: 1.2,
    style: {
      fill: "#a6c7f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.42,
    y: 161.32,
    width: 20.7,
    height: 2.39,
    rx: 1.2,
    style: {
      fill: "#a6c7f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.45,
    y: 161.32,
    width: 20.7,
    height: 2.39,
    rx: 1.2,
    style: {
      fill: "#a6c7f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.48,
    y: 161.32,
    width: 20.7,
    height: 2.39,
    rx: 1.2,
    style: {
      fill: "#a6c7f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.2,
    y: 132.5,
    width: 15.59,
    height: 2.39,
    rx: 1.2,
    style: {
      fill: "#a6c7f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.2,
    y: 132.5,
    width: 15.59,
    height: 2.39,
    rx: 1.2,
    style: {
      fill: "#a6c7f9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.2,
    y: 132.5,
    width: 15.59,
    height: 2.39,
    rx: 1.2,
    style: {
      fill: "#a6c7f9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.600000023841858
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.78,
    y: 182.75,
    width: 35.9,
    height: 34.03,
    style: {
      fill: "#c2dafe"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "125.68 216.84 125.68 217.34 107.59 217.34 111.5 213.43 116.88 208.04 125.68 216.84",
    style: {
      fill: "#c2dafe"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.78 217.34 89.78 213.96 100.9 202.84 115.4 217.34 89.78 217.34",
    style: {
      fill: "#c2dafe"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.65,
    cy: 193.47,
    r: 5.5,
    style: {
      fill: "#c2dafe"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.600000023841858
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.62,
    y: 182.75,
    width: 35.9,
    height: 34.03,
    style: {
      fill: "#c2dafe"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.600000023841858
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.7,
    y: 182.75,
    width: 35.9,
    height: 34.03,
    style: {
      fill: "#c2dafe"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "216.6 216.84 216.6 217.34 198.51 217.34 202.42 213.43 207.8 208.04 216.6 216.84",
    style: {
      fill: "#c2dafe"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.7 217.34 180.7 213.96 191.82 202.84 206.32 217.34 180.7 217.34",
    style: {
      fill: "#c2dafe"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.32,
    y: 192.77,
    width: 21.48,
    height: 24,
    style: {
      fill: "#c2dafe"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.47,
    y: 207.2,
    width: 4.46,
    height: 7.89,
    style: {
      fill: "#e4edfd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.96,
    y: 207.2,
    width: 4.46,
    height: 7.89,
    style: {
      fill: "#e4edfd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.44,
    y: 207.2,
    width: 4.46,
    height: 7.89,
    style: {
      fill: "#e4edfd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.47,
    y: 195.82,
    width: 4.46,
    height: 7.89,
    style: {
      fill: "#e4edfd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.96,
    y: 195.82,
    width: 4.46,
    height: 7.89,
    style: {
      fill: "#e4edfd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.44,
    y: 195.82,
    width: 4.46,
    height: 7.89,
    style: {
      fill: "#e4edfd"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectReportsGraphic);
export default __webpack_public_path__ + "static/media/project_reports_graphic.430aba9d8c6079231c19c96327e80528.svg";
export { ForwardRef as ReactComponent };